import { render } from "./CloudIcon.vue?vue&type=template&id=2090a885&scoped=true&ts=true"
import script from "./CloudIcon.vue?vue&type=script&lang=ts"
export * from "./CloudIcon.vue?vue&type=script&lang=ts"

import "./CloudIcon.vue?vue&type=style&index=0&id=2090a885&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2090a885"]])

export default __exports__